import {
  Box,
  HStack,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsLink } from "react-icons/bs";
import { RiArrowRightSLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { IResources } from "../../../models/course/course-resource.model";
import { getFullDate } from "../../../utils/classOfDegree";

const Links = ({
  files,
  reload,
}: {
  files: IResources[] | undefined;
  reload: any;
}) => {
  const [resources, setResources] = useState<IResources[]>();
  const navigate = useNavigate();

  useEffect(() => {
    if (files) setResources(files);
  }, []);

  useEffect(() => {
    console.log(resources)
  }, [resources]);

  const downloadFile = (url: string | undefined) => {
    // using Java Script method to get PDF file
    if (url) {
      fetch(url).then((response) => {
        response.blob().then((blob) => {
          // Creating new object of PDF file
          const fileURL = window.URL.createObjectURL(blob);
          // Setting various property values
          const alink = document.createElement("a");
          alink.href = fileURL;
          alink.download = url;
          alink.click();
        });
      });
    }
  };
  return (
    <>
      <Box width="80%" mx="auto" pb="200px" pl="75px" pt="50px" bg="white">
        <Box display="flex" alignItems="center">
          <Text
            cursor="pointer"
            onClick={() => reload()}
            color="#1E1E1E"
            fontSize="28px"
            pb="30px"
            fontWeight="600"
          >
            Resources
          </Text>
          <Box paddingTop="8px" pb="30px" paddingRight="2px">
            <RiArrowRightSLine color="#D5D5D5" fontSize="30px" />
          </Box>
          <Text
            color="#B9B9B9"
            fontWeight="600"
            paddingRight="5px"
            fontSize="20px"
            pb="30px"
          >
            Links{" "}
          </Text>
        </Box>
        <Table variant="simple" mt={5} mb="100px">
          <Thead fontWeight="normal" fontSize="15px">
            <Tr color="#828282">
              <Th textTransform="none">File</Th>
              <Th textTransform="none">Size</Th>
              <Th textTransform="none">Uploaded by</Th>
              <Th textTransform="none">Action</Th>
            </Tr>
          </Thead>

          <Tbody>
            {resources && resources.length > 0 ? (
              resources.map((each, index) => (
                <Tr key={index} fontSize="14px" color="#828282">
                  <Td>
                    <HStack>
                      <BsLink fontSize={"40px"} />
                        <Text>{each.file_url && each.file_url.slice(0, 60)}...</Text>
                    </HStack>
                  </Td>
                  <Td>
                    <Text>{each.file_type ? each.file_type : "nil"}</Text>
                  </Td>
                  <Td>
                    <HStack spacing={2}>
                      <Text>{getFullDate(each.created_at)}</Text>
                    </HStack>
                  </Td>

                  <Td>
                    <a target="_blank" href={`https://${each.file_url}`}>
                      go to
                    </a>
                  </Td>
                </Tr>
              ))
            ) : (
              <Box>No resources yet, upload resource</Box>
            )}
          </Tbody>
        </Table>
      </Box>
    </>
  );
};
export default Links;
